import React from 'react';
import PropTypes from 'prop-types';
import * as Style from './style';
import color from '../../../config/colors.json';

const Button = ({
	children,
	type,
	fontSize,
	lineheight,
	padding,
	shadow,
	bordered,
	fit,
	theme,
	to,
	margin,
	height,
    onClick,
    backgroundcolor,
    disabled,
    fontWeight,
    uppercase,
    display,
	id,
	borderRadius,
	textColor,
	hoverColor,
}) => (
    type === 'link'
	? (
		<Style.LinkStyle
			fontSize={fontSize}
			lineheight={lineheight}
			padding={padding}
			shadow={shadow}
			bordered={bordered}
			fit={fit}
			theme={theme}
			to={to}
			fontWeight={fontWeight}
			margin={margin}
			height={height}
			onClick={onClick}
			backgroundcolor={backgroundcolor}
			uppercase={uppercase}
			display={display}
			id={id}
			borderRadius={borderRadius}
		>
			{children}
		</Style.LinkStyle>
	) : (
		<Style.ButtonStyle
			type={type}
			fontSize={fontSize}
			lineheight={lineheight}
			padding={padding}
			shadow={shadow}
			bordered={bordered}
			fit={fit}
			theme={theme}
			margin={margin}
			height={height}
			fontWeight={fontWeight}
			onClick={onClick}
			backgroundcolor={backgroundcolor}
			disabled={disabled}
			uppercase={uppercase}
			display={display}
			id={id}
			borderRadius={borderRadius}
			textColor={textColor}
			hoverColor={hoverColor}
		>
			{children}
		</Style.ButtonStyle>
	)
);

Button.defaultProps = {
	type: 'Button',
	fontSize: '14px',
	lineheight: '20px',
	padding: '10px',
	margin: '0',
    height: 'auto',
    backgroundcolor: color.lightRed,
    onClick: () => {},
    disabled: false,
    fontWeight: 'bold',
    display: 'table',
};

PropTypes.Button = {
	type: PropTypes.string.isRequired,
	children: PropTypes.string.isRequired,
	fontSize: PropTypes.string,
	lineheight: PropTypes.string,
	padding: PropTypes.string,
	shadow: PropTypes.bool,
	bordered: PropTypes.bool,
	fit: PropTypes.bool,
	to: PropTypes.string,
	margin: PropTypes.string,
	height: PropTypes.string,
    onClick: PropTypes.func,
    backgroundcolor: PropTypes.string,
    disabled: PropTypes.Boolean,
    fontWeight: PropTypes.number,
    uppercase: PropTypes.Boolean,
    display: PropTypes.string,
    id: PropTypes.string,
};

export default Button;
